import { LateFeeConfigType } from "../../types/Finance";
import { PagedRequestType, PagedResultsType } from "../../types/PagedResults";
import { get, post, put } from "../../utils/axios-config";
import { LATE_FEE_CONFIGS } from "../../utils/constants";

export const createLateFeeConfig = async (data: LateFeeConfigType) => await post<LateFeeConfigType, string>(LATE_FEE_CONFIGS, data);
export const updateLateFeeConfig = async (data: LateFeeConfigType) => await put<LateFeeConfigType, string>(LATE_FEE_CONFIGS, data);

export const getLateFeeConfigs = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
    });
    if (data?.IdPaymentType) {
        queryParams.append('IdPaymentType', data.IdPaymentType);
    }
    const url = `${LATE_FEE_CONFIGS}?${queryParams.toString()}`;
    return await get<PagedResultsType<LateFeeConfigType>>(url)
};